import { thingMoveEvent } from '@/play/things/things'

/** One drop of a block: its cells moved by a whole-cell offset (one undo step). */
export const READING_SHELF_MOVE = thingMoveEvent('experience.reading-shelf.move')

/** Reducer handlers for Reading shelf (`experience.reading-shelf.*`). */
export const eventHandlers = READING_SHELF_MOVE.handlers
